export default defineNuxtPlugin(() => {
  addRouteMiddleware(
    'layout-guard',
    (to, from) => {
      // console.log('global middleware that runs on every route change')
    },
    { global: true },
  )
})
